module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "content": "text/html; charset=utf-8",
      "http-equiv": "Content-Type"
    }
  }), _vm._v(" "), _c('title', [_vm._v("Remembering Farley")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "style.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "textno",
    staticStyle: {
      "text-align": "center"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "textno",
    staticStyle: {
      "text-align": "center"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "textno",
    staticStyle: {
      "text-align": "center"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "textno",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Most of this book is for Jim Kravets, whose thirst for life matches mine, and whose faith in my talent has always exceeded mine.")])]), _vm._v(" "), _c('p', {
    staticClass: "textno",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Except for the callipygian strips. Those are obviously for Patty.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d708be70","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Frazz-006.vue
// module id = 69
// module chunks = 0